import AppImage from '@/components/ui/AppImage';
import Icon from '@/components/ui/AppIcon';

interface DiningCardProps {
  name: string;
  cuisine: string;
  distance: string;
  priceRange: string;
  rating: number;
  image: string;
  alt: string;
  specialties: string[];
  ambiance: string;
}

const DiningCard = ({
  name,
  cuisine,
  distance,
  priceRange,
  rating,
  image,
  alt,
  specialties,
  ambiance,
}: DiningCardProps) => {
  return (
    <div className="bg-card rounded-xl shadow-subtle hover:shadow-elevated transition-all duration-300 overflow-hidden border border-border group">
      <div className="relative h-48 overflow-hidden">
        <AppImage
          src={image}
          alt={alt}
          className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
        />
        <div className="absolute top-4 right-4 bg-white/90 backdrop-blur-sm px-3 py-1.5 rounded-full flex items-center space-x-1">
          <Icon name="StarIcon" size={16} className="text-accent" variant="solid" />
          <span className="text-sm font-semibold text-text-primary">{rating}</span>
        </div>
      </div>
      
      <div className="p-6">
        <div className="flex items-start justify-between mb-3">
          <div className="flex-1">
            <h3 className="font-display text-xl font-semibold text-text-primary mb-1">
              {name}
            </h3>
            <p className="text-sm text-text-secondary">{cuisine}</p>
          </div>
          <div className="text-right ml-4">
            <p className="text-sm font-medium text-accent">{priceRange}</p>
            <p className="text-xs text-text-secondary">{distance}</p>
          </div>
        </div>
        
        <div className="mb-4">
          <p className="text-sm text-text-secondary mb-2">
            <span className="font-medium text-text-primary">Ambiance:</span> {ambiance}
          </p>
        </div>
        
        <div className="space-y-2">
          <p className="text-sm font-medium text-text-primary">Specialties:</p>
          <div className="flex flex-wrap gap-2">
            {specialties.map((specialty, index) => (
              <span
                key={index}
                className="px-3 py-1 bg-muted text-text-secondary text-xs rounded-full"
              >
                {specialty}
              </span>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default DiningCard;